import React from 'react';
import { selectSponsor, sponsors } from './sponsors';

export default function SponsorBanner({ message, at, bookings = sponsors }) {
  const sponsor = selectSponsor(message, at, bookings);
  if (!sponsor) return null;

  return (
    <aside className="mb-6" aria-label={`Sponsored by ${sponsor.name}`}>
      <div className="flex items-center justify-between gap-3 mb-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Sponsored
        </span>
        <span className="text-xs text-gray-500 dark:text-gray-400">
          {sponsor.name} sponsors {sponsor.service} updates
        </span>
      </div>
      <a
        href={sponsor.url}
        target="_blank"
        rel="sponsored noopener noreferrer"
        className="block border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-950"
      >
        <img
          src={sponsor.image}
          alt={sponsor.alt}
          width="1200"
          height="180"
          className="block w-full h-auto"
        />
      </a>
    </aside>
  );
}